
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GuardCheckInButton extends Vue {

    public checkInLocation() {
        this.$emit("check-guard-in");
    }
}
